import { useApiGet } from '@sierralabs/core-ui';
export function useFindFileLogs(id) {
    return useApiGet(`files/history/${id}`);
}
//# sourceMappingURL=useFindFileLogs.js.map